import video from 'globalCommon/utils/video';
import { showCustomImage, showCustomImageMobile } from 'globalCommon/utils/index';
import commonPageService from 'mCommon/services/commonPageService';
import { syncRender } from 'globalCommon/services/syncRender';
import { UserLogoMap as UserMobileLogoMap } from '../../common/utils/imageSource';
import { UserLogoMap } from 'pcCommon/utils/imageSource';
import './style.css';

function init() {
    showCustomImageMobile(UserMobileLogoMap, 'img-list', 'img-item');
    commonPageService({ renderAfter: syncRender });
    video.init();
}

init();
